import { MENU_CONFIG as MENU_CONFIG_DEV } from "./menu-dev.config";
import { MENU_CONFIG as MENU_CONFIG_PRODUCTION } from "./menu-production.config";

export const DEFAULT_MENU_CONFIG =
  process.env.APP_ENV === "production"
    ? MENU_CONFIG_PRODUCTION
    : MENU_CONFIG_DEV;
